module.exports = __webpack_public_path__ + "img/10_81.9638153c.png";